import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=c36099d2&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=c36099d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36099d2",
  null
  
)

export default component.exports